import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrivacyStateService } from './privacy-state.service';

@Injectable()
export class DevPrivacyStateService extends PrivacyStateService {
  get canSubmitForm(): Observable<boolean> {
    return super.canSubmitForm;
  }

  get canLoadMap(): Observable<boolean> {
    return super.canLoadMap;
  }
}
